import { IconActionChevronDownSmall16 } from '@cian/ui-kit-design-tokens/icons';
import cx from 'clsx';
import * as React from 'react';
import { trackClickPromoListLink } from 'shared/utils/tracking/promos/trackClickPromoListLink';

import * as styles from './styles.css';
import { Link } from '../../../Link';
import { ButtonLink } from '../ButtonLink';

export interface IToggleButtonProps {
  children: React.ReactNode;
  isOpened: boolean;
  onClick(e: React.MouseEvent<HTMLElement>): void;
}

export function ToggleButtonBar({ children, isOpened, onClick }: IToggleButtonProps) {
  return (
    <div className={styles['container']}>
      <ButtonLink onClick={onClick} className={styles['button']}>
        {children}&nbsp;
        <span className={cx(styles['icon'], isOpened && styles['icon--opened'])}>
          <IconActionChevronDownSmall16 color="icon-main-default" display="inline-block" />
        </span>
      </ButtonLink>
      <Link target={'_blank'} className={styles['link']} url={'/skidki/'} onClick={trackClickPromoListLink}>
        Перейти в каталог акций и скидок
      </Link>
    </div>
  );
}
